import Vue from "vue";
import Router from "vue-router";

import CampusEnrollment from "@/routers/CampusEnrollment";
import reportRouters from "@/routers/reportRouters";

Vue.use(Router);

const routes = [
    {
      path: "/",
      name: "index",
      redirect: "/home",
      // component: () => import("./views/Index/index.vue"),
      // children: [
      //   {
      //     path: "/home",
      //     name: "home",
      //     component: () =>
      //       import(/* webpackChunkName: "about" */ "./views/Home.vue")
      //   },
      //   {
      //     path: "/about",
      //     name: "about",
      //     component: () =>
      //       import(/* webpackChunkName: "about" */ "./views/About.vue")
      //   }
      // ]
    },
    // 权限验证
    // 有权限
    {
      path: "/havePermission",
      name: "havePermission",
      component: () => import("./views/Permission/havePermission.vue"),
    },
    {
      path: "/temporaryClosure",
      name: "temporaryClosure",
      component: () => import("./views/TemporaryClosure/temporaryClosure.vue"),
    },
    // 无权限
    {
      path: "/noPermission",
      name: "noPermission",
      component: () => import("./views/Permission/noPermission.vue"),
      // beforeEnter: (to, from, next) => {
      //   var userInfo =JSON.parse(localStorage.getItem("userInfo")); //获取浏览器缓存的用户信息
      //   if(userInfo.data.marketer_id){
      //     next({
      //       path: '/havePermission'
      //     });
      //   }else{
      //     next();
      //   }
      // }
    },
    //首页
    {
      path: "/home",
      name: "home",
      component: () => import("./views/Home/home.vue"),
    },
    //招生目标管理
    {
      path: "/Goalmanage/goalManage",
      name: "goalManage",
      component: () => import("./views/Goalmanage/goalManage.vue"),
    },
    // //招生活动管理
    // {
    //   path: "/Goalmanage/activitiesManage",
    //   name: "activitiesManage",
    //   component: () => import("./views/Goalmanage/activitiesManage.vue")
    // },
    //招生活动管理
    {
      path: "/Crmactivemanage/activitiesManage",
      name: "activitiesManage",
      component: () => import("./views/Crmactivemanage/activitiesManage.vue"),
    },
    {
      path: "/Crmactivemanage/groundPromotionManage",
      name: "groundPromotionManage",
      component: () =>
        import("./views/Crmactivemanage/groundPromotionManage.vue"),
    },
    {
      path: "/ListAllocationManagement/grossList",
      name: "grossList",
      component: () => import("./views/ListAllocationManagement/grossList.vue"),
    },
    {
      path: "/ListAllocationManagement/importGross",
      name: "importGross",
      component: () =>
        import("./views/ListAllocationManagement/importGross.vue"),
    },
    {
      path: "/ListAllocationManagement/importGrossList",
      name: "importGrossList",
      component: () =>
        import("./views/ListAllocationManagement/importGrossList.vue"),
    },
    {
      path: "/ListAllocationManagement/preSetValidList",
      name: "preSetValidList",
      component: () =>
        import("./views/ListAllocationManagement/preSetValidList.vue"),
    },
    {
      path: "/ListAllocationManagement/recruitStaffManage",
      name: "recruitStaffManage",
      component: () =>
        import("./views/ListAllocationManagement/recruitStaffManage.vue"),
    },
    {
      path: "/ListAllocationManagement/sourceManage",
      name: "sourceManage",
      component: () =>
        import("./views/ListAllocationManagement/sourceManage.vue"),
    },
    //跨界活动管理
    {
      path: "/Crmactivemanage",
      name: "Crmactivemanage-Crmactivemanage",
      component: () => import("./views/Crmactivemanage/crossoverActivity.vue"),
      children: [
        {
          path: "crossoverActivityManagement",
          name: "Crmactivemanage-crossoverActivityManagement",
          component: () =>
            import("./views/Crmactivemanage/crossoverActivityManagement.vue"),
        },
        //跨界活动名单
        {
          path: "crossoverActivitiesList",
          name: "crossoverActivitiesList",
          component: () =>
            import("./views/Crmactivemanage/crossoverActivitiesList.vue"),
        },
      ],
    },

    //海报活动管理
    {
      path: "/Crmactivemanage/posterActivitiesManage",
      name: "posterActivitiesManage",
      component: () =>
        import("./views/Crmactivemanage/posterActivitiesManage.vue"),
    },
    //招生劵管理
    {
      path: "/Crmactivemanage/ticketActivity",
      name: "ticketActivity",
      component: () => import("./views/Crmactivemanage/ticketActivity.vue"),
    },
    //招生劵管理****弹框
    {
      path: "/Crmactivemanage/crmTicketMange",
      name: "crmTicketMange",
      component: () => import("./views/Crmactivemanage/crmTicketMange.vue"),
    },
    //招生劵管理****招生名单****弹框
    {
      path: "/Crmactivemanage/crmAdmissionList",
      name: "crmAdmissionList",
      component: () => import("./views/Crmactivemanage/crmAdmissionList.vue"),
    },
    //我的目标
    {
      path: "/Goalmanage/mygoalManage",
      name: "mygoalManage",
      component: () => import("./views/Goalmanage/mygoalManage.vue"),
    },
    //招生有效名单
    {
      path: "/Admissioncue/admissionCue",
      name: "admissionCue",
      component: () => import("./views/Admissioncue/admissionCue.vue"),
    },
    // 名单检索
    {
      path: "/Admissioncue/listSearch",
      name: "listSearch",
      component: () => import("./views/Admissioncue/listSearch.vue"),
    },
    // 招生管理--导入有效名单****导入
    {
      path: "/Admissioncue/importAdmission",
      name: "importAdmission",
      component: () => import("./views/Admissioncue/importAdmission.vue"),
    },
    // 招生管理--导入有效名单****导入列表
    {
      path: "/Admissioncue/importAdmissionList",
      name: "importAdmissionList",
      component: () => import("./views/Admissioncue/importAdmissionList.vue"),
    },
    //意向客户管理
    {
      path: "/Customersmanage/custoMersmanage",
      name: "custoMersmanage",
      component: () => import("./views/Customersmanage/custoMersmanage.vue"),
    },
    // 电销名单跟进
    {
      path: "/Customersmanage/telemarketList",
      name: "telemarketList",
      component: () => import("./views/Customersmanage/telemarketList.vue"),
    },
    // 试听邀约课表
    {
      path: "/Customersmanage/inviteReport",
      name: "inviteReport",
      component: () => import("./views/Customersmanage/inviteReport.vue"),
    },
    // 拨打记录管理
    {
      path: "/Customersmanage/dialRecord",
      name: "dialRecord",
      component: () => import("./views/Customersmanage/dialRecord.vue"),
    },
    // 渠道记录
    {
      path: "/Customersmanage/channelRecord",
      name: "channelRecord",
      component: () => import("./views/Customersmanage/channelRecord.vue"),
    },
    {
      path: "/Customersmanage/ChannelChangeRecord",
      name: "Customersmanage-ChannelChangeRecord",
      component: () => import("@/views/Customersmanage/channelChangeRecord.vue"),
    },
    {
      path: "/Customersmanage/CollisionDetail",
      name: "Customersmanage-CollisionDetail",
      component: () => import("@/views/Customersmanage/channelChangeRecord/collisionDetail.vue"),
    },
    //柜询管理
    {
      path: "/Invitationauditionmanage/invitationManage",
      name: "invitationManage",
      component: () =>
        import("./views/Invitationauditionmanage/invitationManage.vue"),
    },
    //试听管理
    {
      path: "/Invitationauditionmanage/auditionManage",
      name: "auditionManage",
      component: () =>
        import("./views/Invitationauditionmanage/auditionManage.vue"),
    },
    //已报名名单
    {
      path: "/Registeredlist/registeredList",
      name: "registeredList",
      component: () => import("./views/Registeredlist/registeredList.vue"),
    },
    //无意向客户管理
    {
      path: "/Losscustomermanage/losscustomerManage",
      name: "losscustomerManage",
      component: () =>
        import("./views/Losscustomermanage/losscustomerManage.vue"),
    },
    //无效客户管理
    {
      path: "/Losscustomermanage/invalidCustomer",
      name: "invalidCustomer",
      component: () => import("./views/Losscustomermanage/invalidCustomer.vue"),
    },
    //超龄名单管理
    {
      path: "/Losscustomermanage/overageList",
      name: "overageList",
      component: () => import("./views/Losscustomermanage/overageList.vue"),
    },

    //客户管理(未分配到校园的名单)
    {
      path: "/Clientmanage/clientManage",
      name: "clientManage",
      component: () => import("./views/Clientmanage/clientManage.vue"),
    },
    //正在建设中
    {
      path: "/Websitebuilding",
      name: "Websitebuilding",
      component: () => import("./views/websiteBuilding/Websitebuilding.vue"),
    },

    // 校内招生管理
    ...CampusEnrollment,

    // 报表
    ...reportRouters,
  ];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
